'use client';

import { useContext, useEffect, useState, type ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import { StoreContext } from '@/components/providers/store.provider';
import dynamic from 'next/dynamic';

const Action = dynamic(() => import('./components/action'));

export default observer(function Report(): ReactElement | false {
  const { userStore } = useContext(StoreContext);

  const [auth, setAuth] = useState(false);

  useEffect(() => setAuth(userStore.isAuth), [userStore.isAuth]);

  return auth && <Action />;
});
